import lodash from 'lodash';

export default class {

    $get () {
        return lodash;
    }

}



// WEBPACK FOOTER //
// ./src/app/providers/lodash/index.js